import { TemplateKey } from "PFApp/constants/templates";
import { Button, ButtonKind } from "PFComponents/button";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { ShareModal } from "./share_modal";

type ShareButtonProps = {
  activityIds: number[];
  templateKey?: TemplateKey;
  invites?: any[];
  kind?: ButtonKind;
  withText?: boolean;
  onSuccess?: () => void;
};

export const ShareButton = ({
  activityIds,
  invites,
  onSuccess,
  templateKey,
  kind,
  withText = true
}: ShareButtonProps) => {
  const { t } = useTranslation("core");

  const [shown, setShown] = useState(false);

  const noActivityIds = activityIds.length === 0;
  const handleClose = () => {
    setShown(false);
  };

  return (
    <>
      <Button
        disabled={noActivityIds}
        onClick={() => setShown(true)}
        kind={kind}
        text={withText ? t("activityShare.buttonText") : ""}
        title={t("activityShare.buttonText")}
        icon="share"
        iconPlacement="right"
      />
      {shown && (
        <ShareModal
          activityIds={activityIds}
          onClose={handleClose}
          onSuccess={() => {
            onSuccess?.();
            handleClose();
          }}
          templateKey={templateKey}
          invites={invites}
        />
      )}
    </>
  );
};
